import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useProvince } from "@/contexts/ProvinceContext";
import { toast } from "sonner";
import { CheckCircle, BarChart2 } from "lucide-react";

export default function PollsList() {
  const { selected } = useProvince();
  const [active, setActive] = useState(null);
  const [closed, setClosed] = useState([]);
  useEffect(() => {
    const q = selected ? `?province_id=${selected.id}` : "";
    api.get(`/polls${q}`).then((r) => {
      const all = r.data || [];
      setActive(all.find((p) => p.is_active));
      setClosed(all.filter((p) => !p.is_active));
    });
  }, [selected?.id]);
  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-5">Anketler</h1>
      {active && <PollCard poll={active} />}
      {closed.length > 0 && (
        <div className="mt-10">
          <h2 className="text-lg font-bold mb-3">Sonuçlanmış Anketler</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {closed.map((p) => (
              <Link key={p.id} to={`/anketler/${p.id}`} className="bg-white border border-gray-100 rounded-lg p-4 hover:border-[#e11d2a]">
                <div className="font-bold">{p.title}</div>
                <div className="text-xs text-gray-500 mt-1">{p.total_votes || 0} oy</div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function PollCard({ poll }) {
  const { user } = useAuth();
  const [p, setP] = useState(poll);
  const [voted, setVoted] = useState(false);
  const [myOpt, setMyOpt] = useState(null);

  useEffect(() => {
    if (user) api.get(`/polls/${poll.id}/my-vote`).then((r) => { setVoted(r.data.voted); setMyOpt(r.data.option_id); }).catch(() => {});
  }, [user, poll.id]);

  const vote = async (optionId) => {
    if (!user) return toast.error("Oy vermek için giriş yapmalısınız");
    try {
      const r = await api.post(`/polls/${poll.id}/vote`, { option_id: optionId });
      setP(r.data); setVoted(true); setMyOpt(optionId);
      toast.success("Oyunuz alındı");
    } catch (e) { toast.error(e.response?.data?.detail || "Hata oluştu"); }
  };

  const total = p.total_votes || 0;
  return (
    <div className="bg-white border border-gray-100 rounded-lg p-6" data-testid="poll-card">
      <div className="flex items-center gap-2 mb-2">
        <BarChart2 className="w-5 h-5 text-[#e11d2a]" />
        <span className="text-xs uppercase font-bold text-[#e11d2a]">Aktif Anket</span>
      </div>
      <h2 className="text-xl font-black">{p.title}</h2>
      {p.description && <p className="text-sm text-gray-600 mt-1">{p.description}</p>}
      <div className="mt-4 space-y-3">
        {(p.options || []).map((o) => {
          const pct = total ? Math.round((o.votes / total) * 100) : 0;
          return (
            <div key={o.id}>
              {!voted ? (
                <button data-testid={`poll-opt-${o.id}`} onClick={() => vote(o.id)} className="w-full text-left px-4 py-3 border-2 border-gray-100 rounded-lg hover:border-[#e11d2a] font-medium transition">{o.text}</button>
              ) : (
                <div className="relative w-full px-4 py-3 border border-gray-100 rounded-lg overflow-hidden">
                  <div className="absolute inset-y-0 left-0 bg-[#e11d2a]/10" style={{ width: `${pct}%` }}></div>
                  <div className="relative flex justify-between items-center">
                    <span className="font-medium">{o.text} {myOpt === o.id && <CheckCircle className="inline w-4 h-4 text-[#e11d2a] ml-1" />}</span>
                    <span className="text-sm font-bold">{pct}% <span className="text-gray-400 font-normal text-xs">({o.votes})</span></span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="text-xs text-gray-500 mt-3">Toplam {total} oy</div>
    </div>
  );
}

export function PollDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/polls/${id}`).then((r) => setP(r.data)); }, [id]);
  if (!p) return null;
  return <div className="max-w-4xl mx-auto px-4 py-6"><PollCard poll={p} /></div>;
}
